<template>
    <g clip-path="url(#clip0_840_5222)">
        <path
            d="M9.81264 7.51309C9.64386 7.51239 9.48236 7.44417 9.36422 7.32362L6.23789 4.19731L3.11157 7.32362C2.82381 7.52075 2.43072 7.44729 2.23359 7.15952C2.09089 6.95122 2.08596 6.67797 2.22105 6.46467L5.78947 2.88994C6.0351 2.64229 6.43499 2.64065 6.68266 2.88628C6.68389 2.88748 6.68512 2.88871 6.68632 2.88994L10.2547 6.46467C10.4996 6.711 10.4996 7.10886 10.2547 7.35519C10.1331 7.46268 9.9748 7.51921 9.81264 7.51309Z"
            fill="#727EA3"
        />
        <path
            d="M6.23705 12.781C5.88824 12.781 5.60547 12.4983 5.60547 12.1495V3.30737C5.60547 2.95856 5.88824 2.67578 6.23705 2.67578C6.58586 2.67578 6.86864 2.95856 6.86864 3.30737V12.1495C6.86864 12.4983 6.58586 12.781 6.23705 12.781Z"
            fill="#727EA3"
        />
        <path
            d="M10.0269 2.0444H2.44799C2.09918 2.0444 1.81641 1.76162 1.81641 1.41281C1.81641 1.064 2.09918 0.78125 2.44799 0.78125H10.0269C10.3757 0.78125 10.6585 1.06403 10.6585 1.41284C10.6585 1.76165 10.3757 2.0444 10.0269 2.0444Z"
            fill="#727EA3"
        />
    </g>
    <defs>
        <clipPath id="clip0_840_5222">
            <rect width="12" height="12" fill="white" transform="translate(0.238281 0.78125)" />
        </clipPath>
    </defs>
</template>
